import { desktopBreakpoint, tabletBreakpoint } from 'common/responsive';

const carouselSettings = {
  swipe: true,
  slidesToShow: 3,
  dots: false,
  arrows: false,
  slidesToScroll: 1,
  centerPadding: '0',
  initialSlide: 1,
  centerMode: true,
  infinite: true,
  responsive: [
    {
      breakpoint: desktopBreakpoint,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: tabletBreakpoint,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export default carouselSettings;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/carouselSettings.js